import React from 'react';
import withShipment from '../../../withShipment';
import {
  createCompany,
  generateLicenseKey,
  getCompanyMemberships,
  getLicenseKey,
  handleRenewLicenseKey,
  listCompanies,
  listMasterAdminsPerLocation,
  revokeLicenseKey,
  updateCompany,
  updateLicensePayment,
  markCyclePaid,
} from '../../../redux/actions/settings';
import CustomToolbar from '../../global/CustomToolbar';
import {
  BACK_TO_MENU_TITLE,
  DEFAULT_ROWS_PER_PAGE,
  DEFAULT_SORT_BY_HEAD_CELL,
  CREATE_COMPANY_TITLE,
  MANAGE_COMPANY_TABLE_HEAD_CELLS,
  COMPANY_TOOLBAR_TITLE,
  PLAN_BADGE_COLORS,
} from './constants';
import CompanyWizardV3 from './CompanyWizardV3';
import Paper from '@material-ui/core/Paper';
import { IconButton, TextField, InputAdornment } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import { ASC, DEFAULT_PDF_ZOOM } from '../../global/constants';
import SearchableTable from '../../global/Search/SearchableTable';
import { userInfoSelector } from '../../../redux/selectors/auth';
import ErrorFeedbackBar from '../../global/ErrorFeedbackBar';
import { Layout } from '../../global/Table/TablePageHelpers/LayoutObject';
import { Tooltip } from '@mui/material';
import TablePage from '../../global/Table/TablePage';
import {
  companyMembershipsSelector,
  companySelector,
  licenseKeySelector,
  masterAdminsLocationSelector,
} from '../../../redux/selectors/account';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import FeedbackBar from '../../feedbackBar/FeedbackBar';
import { clearStatus } from '../../../redux/actions/global';
import { statusSelector } from '../../../redux/selectors/global';
import Utils from '../../Utils/Utils';
import { globalPDFPreviewReadySelector } from '../../../redux/selectors/ticketOut';
import {
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
} from '../../../redux/actions/ticketOut';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import SaveIcon from '@material-ui/icons/Save';
import { BACK } from '../../employeeSession/constants';
import { GetApp } from '@material-ui/icons';
import PrintIcon from '@mui/icons-material/Print';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RenderPurchaseOrderPDFPreview from '../../transaction/RenderPurchaseOrderPDFPreview';
import AssignmentIcon from '@mui/icons-material/Assignment';
import MembershipSummary from './MembershipSummary';
import PaymentHistoryDialog from './PaymentHistoryDialog';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { getRoles } from '../../../redux/actions/userManagement';
import { rolesSelector } from '../../../redux/selectors/userManagement';
import OnboardingRequests from './OnboardingRequestsDialog';
import {
  listOnboardingRequests,
  updateOnboardingRequest,
  activateOnboardingRequest,
  sendOnboardingWelcome,
} from '../../../redux/actions/onboarding';
import { onboardingRequestsSelector } from '../../../redux/selectors/onboarding';
import Badge from '@material-ui/core/Badge';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import PlansPricingManager from './PlansPricingManager';
import {
  loadPlanCatalog,
  previewPlanCatalog,
  publishPlanCatalog,
  applyPendingPlanCatalog,
  setCompanyCustomRate,
} from '../../../redux/actions/planCatalog';
import {
  planCatalogOverviewSelector,
  planCatalogLoadingSelector,
} from '../../../redux/selectors/planCatalog';

class ManageCompanyTable extends SearchableTable {
  constructor(props) {
    super(props);
    this.membershipRef = React.createRef();
    // Lets the toolbar's Save Changes button drive the edit form, which owns
    // the payload for every tab.
    this.wizardRef = React.createRef();
    this.state = {
      page: 0,
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      addingCompany: false,
      editingCompany: null,
      // After a successful create we keep the wizard open on its
      // confirmation screen (so the owner can copy the Master Admin
      // credentials) and only reload the table once they close it.
      reloadOnClose: false,
      order: ASC,
      orderBy: DEFAULT_SORT_BY_HEAD_CELL,
      isSearch: false, // true if search value is not empty, false otherwise
      searchValue: '', // the value in the search field (updates on change)
      searchRows: 0, // number of rows displayed while search criteria is met
      //PRINT
      showPdfViewer: false,
      pdfLoadSuccess: true,
      pdfData: [],
      scale: DEFAULT_PDF_ZOOM,
      isSummary: false,
      paymentHistoryOpen: false,
      paymentHistoryCompany: null,
      onboardingOpen: false,
      // Plans & Pricing — the rate card every price in the system is quoted
      // from. NDS-only, so the toolbar button is owner-gated below.
      plansOpen: false,
      companyFilter: 'all', // 'all' | 'global' | 'alpha'
      // Onboarding invoice PDF preview (rendered with the same viewer + toolbar
      // controls as the Master Reading / Active Membership report).
      invoicePreview: false,
      invoicePdf: null,
      invoiceOrderNumber: null,
    };
  }

  // Bytes come up from OnboardingRequests (it does the /onboarding/invoice
  // fetch); we just store them and flip into the shared PDF viewer.
  showInvoice = (orderNumber, bytes) =>
    this.setState({
      invoicePreview: true,
      invoicePdf: bytes,
      invoiceOrderNumber: orderNumber,
      scale: DEFAULT_PDF_ZOOM,
    });

  closeInvoice = () =>
    this.setState({
      invoicePreview: false,
      invoicePdf: null,
      invoiceOrderNumber: null,
    });

  downloadInvoice = () =>
    Utils.handlePdfAction(
      this.state.invoicePdf,
      'download',
      `Invoice-${this.state.invoiceOrderNumber}.pdf`
    );

  printInvoice = () =>
    Utils.handlePdfAction(
      this.state.invoicePdf,
      'print',
      `Invoice-${this.state.invoiceOrderNumber}.pdf`
    );

  openOnboarding = () => {
    // Refresh so newly-paid sign-ups appear when the screen is opened.
    this.props.listOnboardingRequests({});
    this.setState({ onboardingOpen: true });
  };

  closeOnboarding = () => this.setState({ onboardingOpen: false });

  openPlans = () => this.setState({ plansOpen: true });

  closePlans = () => this.setState({ plansOpen: false });

  // Only NDS (ROLE_OWNER) defines plans — a customer's own admins buy one,
  // they don't price one. The backend enforces the same rule; this keeps a
  // button they'd only get a 403 from off their toolbar.
  isPlatformOwner = () =>
    !!this.props.userInfo?.authority?.includes('ROLE_OWNER');

  openPaymentHistory = (row) => {
    this.setState({
      paymentHistoryOpen: true,
      paymentHistoryCompany: row,
    });
  };

  closePaymentHistory = () => {
    this.setState({
      paymentHistoryOpen: false,
      paymentHistoryCompany: null,
    });
  };

  componentDidMount() {
    this.props.listCompanies();
    this.props.getRoles({
      locationId: this.props.userInfo.selectedLocationId,
      type: 'company',
    });
    // Pull onboarding sign-up requests so the toolbar badge reflects how
    // many are awaiting technician setup.
    this.props.listOnboardingRequests({});
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.status.statusText &&
      prevProps.status.statusText !== this.props.status.statusText
    ) {
      this.openFeedbackBar();
    }
    if (
      !this.arrayEquals(prevProps.PDFPreviewReady, this.props.PDFPreviewReady)
    ) {
      this.setState({
        pdfData: this.props.PDFPreviewReady,
      });
    }
  }

  //report

  showPdfErrorMessage = (isFailed) => {
    this.props.resetGlobalPdfPreviewData();
    this.setState({ pdfLoadSuccess: !isFailed });
  };

  closePdfViewer = () => {
    this.setState({ showPdfViewer: false, pdfData: '' }); // Close the PDF viewer and reset URL
  };

  download = () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    const fileName = `${this.props.userInfo.firstname} Active Membership Report - ${getTodayDate}.pdf`;

    Utils.handlePdfAction(this.state.pdfData, 'download', fileName);
  };

  setZoom(zoom) {
    let newScale = Math.min(Math.max(this.state.scale + zoom, 1), 2);
    this.setState({
      scale: newScale,
    });
  }

  arrayEquals(arr1, arr2) {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  fetchPdf = async () => {
    this.props.getGlobalPDFPreview(
      null,
      this.showPdfErrorMessage,
      'previewActiveMembership'
    );

    this.setState({ showPdfViewer: true });
  };

  //end report

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState(
      { feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' },
      () => {
        this.props.clearStatus();
      }
    );
  };

  saveEditingCompany = () => {
    if (this.wizardRef.current && this.wizardRef.current.handleTopSave) {
      this.wizardRef.current.handleTopSave();
    }
  };

  handleOpenCompany = (row) => {
    this.setState({
      editingCompany: row,
    });
  };

  handleClose = () => {
    // A create just happened — the wizard was showing the credentials
    // confirmation. Reload now (on close) to pull the new company into the
    // table, instead of reloading immediately and hiding the credentials.
    if (this.state.reloadOnClose) {
      window.location.reload();
      return;
    }
    this.setState(
      {
        addingCompany: false,
      },
      () => this.setState({ editingCompany: null })
    );
  };

  // `keepOpen` comes from the edit form's top save bar: the admin is saving
  // mid-edit and expects to stay on the tab they are working in, so don't
  // tear the form down the way the final "SAVE CHANGES" button does.
  handleSave = (addingCompany, data, onSuccess, keepOpen) => {
    // CompanyWizardV3 handles its own validation before invoking onSave,
    // so the table only forwards the payload to the appropriate action.
    const dataToPost = { ...data };
    if (addingCompany) {
      this.props.createCompany(dataToPost, () => {
        if (onSuccess) onSuccess();
        // Don't reload yet — let the wizard render its confirmation screen
        // with the Master Admin credentials. handleClose reloads once the
        // owner dismisses the wizard.
        this.setState({ reloadOnClose: true });
      });
    } else {
      const updatePayload = { ...data, companyId: data.companyId };
      this.props.updateCompany(updatePayload, () => {
        if (onSuccess) onSuccess();
        if (keepOpen) {
          // The form stays up, so confirm the save here instead.
          this.openFeedbackBar('success', 'Changes saved.');
          return;
        }
        this.setState({ addingCompany: false }, () =>
          this.setState({ editingCompany: null })
        );
      });
    }
  };

  getTableHeaders = () => {
    let headers = [];
    headers.push(Layout.columnHead(null, null, null));
    MANAGE_COMPANY_TABLE_HEAD_CELLS.forEach((headCell) => {
      headers.push(Layout.columnHead(headCell.label, headCell.id, 'center'));
    });
    return headers;
  };

  creatingCompany = () => {
    this.setState({
      addingCompany: true,
    });
  };

  cancelCompany = () => {
    // Same as handleClose: if a create just completed, reload so the new
    // company shows up in the table once the wizard is dismissed.
    if (this.state.reloadOnClose) {
      window.location.reload();
      return;
    }
    this.setState({
      addingCompany: false,
      editingCompany: false,
    });
  };

  // Anything not explicitly 'alpha' is treated as a global company (legacy /
  // default rows like NuVe System have no companyType).
  companyTypeOf = (c) => (c && c.companyType === 'alpha' ? 'alpha' : 'global');

  setCompanyFilter = (companyFilter) => this.setState({ companyFilter });

  handleCompanySearch = (e) => {
    const value = e.target.value;
    this.setState({ searchValue: value });
  };

  companyTypeCounts = () => {
    const all = this.props.companies || [];
    const alpha = all.filter((c) => this.companyTypeOf(c) === 'alpha').length;
    return { all: all.length, global: all.length - alpha, alpha };
  };

  // Companies after the type chip + name/companyCode search, NuVe System pinned.
  filteredCompanies = () => {
    let rows = [...(this.props.companies || [])];
    const q = (this.state.searchValue || '').trim().toLowerCase();
    if (q) {
      rows = rows.filter(
        (c) =>
          (c.name || '').toLowerCase().includes(q) ||
          String(c.companyCode || '')
            .toLowerCase()
            .includes(q)
      );
    }
    if (this.state.companyFilter !== 'all') {
      rows = rows.filter(
        (c) => this.companyTypeOf(c) === this.state.companyFilter
      );
    }
    return rows.sort((a, b) => {
      if (a.name === 'NuVe System') return -1;
      if (b.name === 'NuVe System') return 1;
      return 0;
    });
  };

  viewMembershipSummary = () => {
    this.setState({
      isSummary: true,
    });
  };

  closeMembershipSummary = () => {
    this.setState({
      isSummary: false,
    });
  };

  render() {
    const { showPdfViewer, pdfData, scale, isSummary } = this.state;

    let headerButtons = [];

    if (this.state.invoicePreview) {
      headerButtons.push(
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.closeInvoice(),
          title: BACK,
        },
        {
          icon: <GetApp />,
          handler: () => this.downloadInvoice(),
          title: 'Download PDF',
        },
        {
          icon: <PrintIcon />,
          handler: () => this.printInvoice(),
          title: 'Print PDF',
        },
        {
          icon: <ZoomOutIcon />,
          handler: () => this.setZoom(-0.25),
          title: 'Zoom Out',
          disabled: false,
        },
        {
          divider: (
            <span style={{ padding: '5px', marginTop: '5px' }}>
              {this.state.scale * 100}%
            </span>
          ),
        },
        {
          icon: <ZoomInIcon />,
          handler: () => this.setZoom(0.25),
          title: 'Zoom In',
          disabled: false,
        }
      );
    } else if (showPdfViewer) {
      headerButtons.push(
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.closePdfViewer(),
          title: BACK,
        },
        {
          icon: <GetApp />,
          handler: () => this.download(),
          title: 'Download PDF',
        },
        {
          icon: <PrintIcon />,
          title: 'Print PDF',
          handler: () => {
            if (!this.state.pdfData) return;
            Utils.handlePdfAction(
              this.state.pdfData,
              'print',
              'company-report-print.pdf'
            );
          },
        },
        {
          icon: <ZoomOutIcon />,
          handler: () => this.setZoom(-0.25),
          title: 'Zoom Out',
          disabled: false,
        },
        {
          divider: (
            <span style={{ padding: '5px', marginTop: '5px' }}>
              {this.state.scale * 100}%
            </span>
          ),
        },
        {
          icon: <ZoomInIcon />,
          handler: () => this.setZoom(0.25),
          title: 'Zoom In',
          disabled: false,
        }
      );
    } else if (isSummary) {
      headerButtons = [
        {
          icon: <KeyboardBackspaceIcon />,
          handler: this.closeMembershipSummary,
          title: 'Back',
        },
        {
          icon: <GetApp />,
          handler: () => {
            if (
              this.membershipRef.current &&
              this.membershipRef.current.downloadPDF
            ) {
              this.membershipRef.current.downloadPDF();
            }
          },
          title: 'Download PDF',
        },
      ];
    } else if (this.state.onboardingOpen) {
      headerButtons = [
        {
          icon: <KeyboardBackspaceIcon />,
          handler: this.closeOnboarding,
          title: 'Back',
        },
      ];
    } else if (this.state.plansOpen) {
      headerButtons = [
        {
          icon: <KeyboardBackspaceIcon />,
          handler: this.closePlans,
          title: 'Back',
        },
      ];
    } else {
      if (!this.state.editingCompany && !this.state.addingCompany) {
        const pendingOnboarding = (this.props.onboardingRequests || []).filter(
          (r) => r.status === 'Pending Setup'
        ).length;
        headerButtons = [
          {
            icon: <AddCircleIcon />,
            handler: this.creatingCompany,
            title: 'Create new company',
          },
          {
            icon: <AssignmentIcon />,
            title: 'Membership Summary',
            handler: () => this.viewMembershipSummary(),
          },
          {
            icon: (
              <Badge
                badgeContent={pendingOnboarding}
                color="error"
                overlap="rectangular"
              >
                <PendingActionsIcon />
              </Badge>
            ),
            title: 'Onboarding requests',
            handler: this.openOnboarding,
          },
        ];
        if (this.isPlatformOwner()) {
          headerButtons.push({
            icon: <LocalOfferIcon />,
            title: 'Plans & pricing',
            handler: this.openPlans,
          });
        }
      } else {
        headerButtons = [
          {
            icon: <KeyboardBackspaceIcon />,
            handler: this.cancelCompany,
            title: 'Back',
          },
        ];
        // Edit only: save from wherever you are, without stepping through
        // the remaining tabs to reach the footer button.
        if (this.state.editingCompany) {
          headerButtons.push({
            icon: <SaveIcon />,
            handler: this.saveEditingCompany,
            title: 'Save changes',
          });
        }
      }
    }

    return (
      <>
        <Paper className="paper">
          <FeedbackBar
            open={this.state.feedbackBarOpen}
            handleClose={this.closeFeedbackBar}
            severity={this.state.feedbackStatus}
            message={this.state.feedbackMessage}
          />
          <ErrorFeedbackBar />
          <CustomToolbar
            title={
              this.state.invoicePreview
                ? `Invoice · ${this.state.invoiceOrderNumber || ''}`.trim()
                : isSummary
                ? 'Membership Summary'
                : this.state.onboardingOpen
                ? 'Onboarding Requests'
                : this.state.plansOpen
                ? 'Plans & Pricing'
                : this.state.addingCompany
                ? 'Create Company'
                : this.state.editingCompany
                ? `Edit ${this.state.editingCompany.name || ''}`.trim()
                : COMPANY_TOOLBAR_TITLE
            }
            createTitle={CREATE_COMPANY_TITLE}
            backTitle={BACK_TO_MENU_TITLE}
            onClick={() => {
              this.setState({ addingCompany: true });
            }}
            handleClose={this.handleClose}
            headerButtons={headerButtons}
          />

          {this.state.invoicePreview ? (
            <RenderPurchaseOrderPDFPreview
              data={this.state.invoicePdf}
              creating={true}
              scale={scale}
            />
          ) : this.state.plansOpen ? (
            <PlansPricingManager
              overview={this.props.planCatalogOverview}
              loading={this.props.planCatalogLoading}
              onLoad={this.props.loadPlanCatalog}
              onPreview={this.props.previewPlanCatalog}
              onPublish={this.props.publishPlanCatalog}
              onApplyPending={this.props.applyPendingPlanCatalog}
              onSetCustomRate={this.props.setCompanyCustomRate}
            />
          ) : this.state.onboardingOpen ? (
            <OnboardingRequests
              requests={this.props.onboardingRequests}
              onUpdate={this.props.updateOnboardingRequest}
              onActivate={this.props.activateOnboardingRequest}
              onSendWelcome={this.props.sendOnboardingWelcome}
              onShowInvoice={this.showInvoice}
            />
          ) : this.state.isSummary ? (
            <MembershipSummary
              ref={this.membershipRef}
              memberships={this.props.companyMemberships}
              getCompanyMemberships={this.props.getCompanyMemberships}
              updateLicensePayment={this.props.updateLicensePayment}
              markCyclePaid={this.props.markCyclePaid}
            />
          ) : showPdfViewer ? (
            <RenderPurchaseOrderPDFPreview
              data={pdfData}
              handleSubmit={this.handleSubmit}
              creating={true}
              handlePdfLoadSuccess={this.props.handlePdfLoadSuccess}
              handlePdfLoadError={this.props.handlePdfLoadError}
              scale={scale}
            />
          ) : !this.state.editingCompany ? (
            this.state.addingCompany ? (
              <CompanyWizardV3
                companies={this.props.companies}
                onClose={this.handleClose}
                onSave={(payload, onSuccess) =>
                  this.handleSave(true, payload, onSuccess)
                }
              />
            ) : (
              <>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    flexWrap: 'wrap',
                    padding: '14px 16px 4px',
                  }}
                >
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    {(() => {
                      const cc = this.companyTypeCounts();
                      const chips = [
                        {
                          label: 'All',
                          value: 'all',
                          count: cc.all,
                          accent: '#0f1847',
                        },
                        {
                          label: 'Global',
                          value: 'global',
                          count: cc.global,
                          accent: '#1a3a8f',
                        },
                        {
                          label: 'Alpha',
                          value: 'alpha',
                          count: cc.alpha,
                          accent: '#D4AF37',
                        },
                      ];
                      return chips.map((ch) => (
                        <CompanyFilterChip
                          key={ch.value}
                          label={ch.label}
                          count={ch.count}
                          accent={ch.accent}
                          active={this.state.companyFilter === ch.value}
                          onClick={() => this.setCompanyFilter(ch.value)}
                        />
                      ));
                    })()}
                  </div>
                  <span style={{ flex: 1 }} />
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Search by name or code"
                    value={this.state.searchValue}
                    onChange={this.handleCompanySearch}
                    style={{ minWidth: 240 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon
                            style={{ color: '#9aa6bd', fontSize: 20 }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <TablePage
                  tableName="companyTable"
                  tableRows={this.filteredCompanies()}
                  tableColumnHeads={this.getTableHeaders()}
                  tableRow={(row, index) => {
                    const isNDS = row.name === 'NuVe System';
                    // Testing companies (anything with "testing" in the
                    // name, case-insensitive) are internal and never
                    // billed — hide payment history same as NDS.
                    const isTesting = (row.name || '')
                      .toLowerCase()
                      .includes('testing');
                    const isOwner =
                      this.props.userInfo?.authority?.includes('ROLE_OWNER');
                    const canEdit = !isNDS || isOwner;
                    return (
                      <React.Fragment>
                        <TableCell
                          style={{
                            textAlign: 'center',
                            width: '1%',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {canEdit && (
                            <Tooltip title={'Edit company'}>
                              <IconButton
                                onClick={() => this.handleOpenCompany(row)}
                              >
                                <EditIcon fontSize="medium" />
                              </IconButton>
                            </Tooltip>
                          )}
                          {!isNDS && !isTesting ? (
                            <Tooltip title={'Payment history'}>
                              <IconButton
                                onClick={() => this.openPaymentHistory(row)}
                              >
                                <ReceiptIcon fontSize="medium" />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            // Invisible placeholder so the edit icon stays
                            // x-aligned across rows that hide the receipt
                            // button (NDS, testing companies).
                            <IconButton
                              disabled
                              style={{ visibility: 'hidden' }}
                              aria-hidden="true"
                            >
                              <ReceiptIcon fontSize="medium" />
                            </IconButton>
                          )}
                        </TableCell>
                        <TableCell style={{ textAlign: 'center' }}>
                          {row.companyCode
                            ? `${row.name} (${row.companyCode})`
                            : row.name}
                        </TableCell>

                        <TableCell style={{ textAlign: 'center' }}>
                          {row?.planName ? (
                            <span
                              style={{
                                display: 'inline-block',
                                padding: '4px 10px',
                                borderRadius: '999px',
                                color: '#fff',
                                fontSize: '12px',
                                fontWeight: 700,
                                letterSpacing: '0.3px',
                                background:
                                  PLAN_BADGE_COLORS[row.planName] || '#6B7280',
                              }}
                            >
                              {row.planName}
                            </span>
                          ) : null}
                        </TableCell>

                        <TableCell style={{ textAlign: 'center' }}>
                          {row?.status === 'active' ? (
                            <Tooltip title="Active">
                              <ToggleOnIcon
                                style={{ color: 'green', fontSize: '36px' }}
                              />
                            </Tooltip>
                          ) : row?.status === 'closed' ? (
                            <Tooltip title="Closed">
                              <ToggleOffIcon
                                style={{ color: 'red', fontSize: '36px' }}
                              />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Hold">
                              <ToggleOffIcon
                                style={{ color: 'orange', fontSize: '36px' }}
                              />
                            </Tooltip>
                          )}
                        </TableCell>
                      </React.Fragment>
                    );
                  }}
                  onRowDoubleClick={(row) => {
                    const isNDS = row.name === 'NuVe System';
                    const isOwner =
                      this.props.userInfo?.authority?.includes('ROLE_OWNER');
                    if (!isNDS || isOwner) this.handleOpenCompany(row);
                  }}
                />
              </>
            )
          ) : (
            <CompanyWizardV3
              ref={this.wizardRef}
              mode="edit"
              editingCompany={this.state.editingCompany}
              companies={this.props.companies}
              licenseKey={this.props.licenseKey}
              getLicenseKey={this.props.getLicenseKey}
              handleRenewLicenseKey={this.props.handleRenewLicenseKey}
              revokeLicenseKey={this.props.revokeLicenseKey}
              listCompanies={this.props.listCompanies}
              onClose={this.handleClose}
              onSave={(payload, onSuccess, keepOpen) =>
                this.handleSave(false, payload, onSuccess, keepOpen)
              }
            />
          )}
        </Paper>
        <PaymentHistoryDialog
          open={this.state.paymentHistoryOpen}
          companyId={this.state.paymentHistoryCompany?.companyId}
          companyName={this.state.paymentHistoryCompany?.name}
          onClose={this.closePaymentHistory}
        />
      </>
    );
  }
}

function CompanyFilterChip({ label, count, accent, active, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        border: `1.5px solid ${active ? accent : '#E5EAF4'}`,
        background: active ? `${accent}14` : '#fff',
        color: active ? '#0A1640' : '#5B6781',
        fontWeight: 700,
        fontSize: 13.5,
        padding: '7px 14px',
        borderRadius: 999,
        cursor: 'pointer',
      }}
    >
      <span
        style={{
          width: 9,
          height: 9,
          borderRadius: '50%',
          background: accent,
          display: 'inline-block',
        }}
      />
      {label}
      <span
        style={{
          minWidth: 20,
          textAlign: 'center',
          background: active ? accent : '#EEF1F7',
          color: active ? '#fff' : '#5B6781',
          fontSize: 12,
          fontWeight: 800,
          borderRadius: 999,
          padding: '1px 7px',
        }}
      >
        {count}
      </span>
    </button>
  );
}

const mapStateToProps = (state) => ({
  status: statusSelector(state),
  companies: companySelector(state),
  userInfo: userInfoSelector(state),
  licenseKey: licenseKeySelector(state),
  PDFPreviewReady: globalPDFPreviewReadySelector(state),
  companyMemberships: companyMembershipsSelector(state),
  roles: rolesSelector(state),
  masterAdminsLocation: masterAdminsLocationSelector(state),
  onboardingRequests: onboardingRequestsSelector(state),
  planCatalogOverview: planCatalogOverviewSelector(state),
  planCatalogLoading: planCatalogLoadingSelector(state),
});

const actionCreators = {
  clearStatus,
  createCompany,
  updateCompany,
  listCompanies,
  generateLicenseKey,
  handleRenewLicenseKey,
  getLicenseKey,
  revokeLicenseKey,
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
  getCompanyMemberships,
  updateLicensePayment,
  markCyclePaid,
  getRoles,
  listMasterAdminsPerLocation,
  listOnboardingRequests,
  updateOnboardingRequest,
  activateOnboardingRequest,
  sendOnboardingWelcome,
  loadPlanCatalog,
  previewPlanCatalog,
  publishPlanCatalog,
  applyPendingPlanCatalog,
  setCompanyCustomRate,
};

export default withShipment(
  {
    mapStateToProps,
    actionCreators,
  },
  ManageCompanyTable
);
